import { render, staticRenderFns } from "./order_product_list.vue?vue&type=template&id=91015746&scoped=true"
import script from "./order_product_list.vue?vue&type=script&lang=js"
export * from "./order_product_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91015746",
  null
  
)

export default component.exports